import { defineStore } from "pinia";

export const useConnectionStore = defineStore('connectionStore', {
  state : () => ({
    cookie : null,
    dummy : null,

    isSubscriber : null,
    subscriberExpireDate : null,
    subscriberExpireDisplayString : null,
    lastStartupCheckDate : null,
    lastNewInfoDate : null,
    coordinateLocation : null,
    verified : null,

    // darkmode - set by system for overall screen.
    // darkBoardColors - what colors to use in dark mode
    darkmode : null,
    darkBoardColors : null,

    email : null,
    isMe : null,

    lichessAccessToken : null,
    lichessUserid : null,
    lichessGameId : null,
    lichessFriendId : "",
    lichessFriendName : "",

    // type of puzzle (or string to pass with router)
    puzzleType : "",
    playComputerGameId : null,
    reviewGameId : null,

    // home page for www.verbalchess.fun
    verbalHomePage : ""

  }),
  getters: {
    getCoordinateLocation() {
      if (this.coordinateLocation == null)
        this.coordinateLocation = localStorage.getItem("coordinateLocation")
      if (this.coordinateLocation == null)
        this.coordinateLocation = "in"
      return (this.coordinateLocation)
    },
    getIsSubscriber() {
      if (this.isSubscriber == null)
        this.isSubscriber = localStorage.getItem("isSubscriber")
      if (this.isSubscriber == null || this.isSubscriber != "1")
        this.isSubscriber = "0"
      return (this.isSubscriber)
    },
    getSubscriberExpireDate() {
      if (this.subscriberExpireDate == null)
        this.subscriberExpireDate = localStorage.getItem("subscriberExpireDate")
      if (this.subscriberExpireDate == null)
        this.subscriberExpireDate = 0
      return (this.subscriberExpireDate)
    },
    getSubscriberExpireDisplayString() {
      if (this.subscriberExpireDisplayString == null)
        this.subscriberExpireDisplayString = localStorage.getItem("subscriberExpireDisplayString")
      if (this.subscriberExpireDisplayString == null)
        this.subscriberExpireDisplayString = ""
      return (this.subscriberExpireDisplayString)
    },
    getIsMe() {
      if (this.isMe == null)
        this.isMe = localStorage.getItem("isMe")
      if (this.isMe == null)
        this.isMe = "0"
      return this.isMe
    },
    getEmailVerified() {
      if (this.verified == null)
        this.verified = localStorage.getItem("emailVerified")
      if (this.verified == null)
        this.verified = "no"
      return this.verified
    },
    getEmailAddress() {
      if (this.email == null)
        this.email = localStorage.getItem("email")
      if (this.email == null)
        this.email = ""
      return this.email
    },
    getCookie() {
      //console.log("IN GET COOKIE",localStorage.getItem("cookie"))
      if (this.cookie == null)
        this.cookie = localStorage.getItem("cookie")
      if (this.cookie == null)
        this.cookie = ""

      return this.cookie
    },
    getDummy() {
      if (this.dummy == null)
        this.dummy = localStorage.getItem("dummy")
      if (this.dummy == null)
        this.dummy = "1"
      return this.dummy
    },
    getDarkBoardColors() {
      if (this.darkBoardColors == null)
        this.darkBoardColors = localStorage.getItem("darkBoardColors")
      if (this.darkBoardColors == null)
        this.darkBoardColors = "dark"
      return this.darkBoardColors
    },
    getDarkmode() {
      // see if darkmode already set, also fix any old values
      if (this.darkmode == null)
        this.darkmode = localStorage.getItem("dark")
      if (this.darkmode == null || this.darkmode == "n" || this.darkmode == "")
        this.darkmode = "light"
      else
      if (this.darkmode == "y")
        this.darkmode = "dark"
      return (this.darkmode)
    },
    getLastStartupCheckDate() {
      if (this.lastStartupCheckDate == null)
        this.lastStartupCheckDate = localStorage.getItem("lastStartupCheckDate")
      if (this.lastStartupCheckDate == null)
        this.lastStartupCheckDate = "0"
      return this.lastStartupCheckDate
    },
    getLastNewInfoDate() {
      if (this.lastNewInfoDate == null)
        this.lastNewInfoDate = localStorage.getItem("lastNewInfoDate")
      if (this.lastNewInfoDate == null)
        this.lastNewInfoDate = 0
      return (this.lastNewInfoDate)
    },
    getPuzzleType() {
      this.puzzleType = localStorage.getItem("puzzleType")
      return this.puzzleType
    },
    getPlayComputerGameId() {
      if (this.playComputerGameId == null)
        this.playComputerGameId = localStorage.getItem("playComputerGameId")
      if (this.playComputerGameId == null)
        this.playComputerGameId = "0"
      return this.playComputerGameId
    },
    getReviewGameId() {
      if (this.reviewGameId == null)
        this.reviewGameId = localStorage.getItem("reviewGameId")
      if (this.reviewGameId == null)
        this.reviewGameId = "0"
      return this.reviewGameId
    },
    getLichessGameId() {
      if (this.lichessGameId == null)
        this.lichessGameId = localStorage.getItem("lichessGameId")
      if (this.lichessGameId == null)
        this.lichessGameId = ""
      return this.lichessGameId
    },
    getLichessAccessToken() {
      if (this.lichessAccessToken == null)
        this.lichessAccessToken = localStorage.getItem("lichessAccessToken")
      if (this.lichessAccessToken == null)
        this.lichessAccessToken = ""
      return (this.lichessAccessToken)
    },
    getLichessUserid() {
      if (this.lichessUserid == null)
        this.lichessUserid = localStorage.getItem("lichessUserid")
      if (this.lichessUserid == null)
        this.lichessUserid = ""
      return (this.lichessUserid)
    },
    getLichessFriend() {
      this.lichessFriendId = localStorage.getItem("lichessFriendId")
      this.lichessFriendName = localStorage.getItem("lichessFriendName")
      return { id : this.lichessFriendId , name : this.lichessFriendName }
    },
    getVerbalHomePage() {
      this.verbalHomePage = localStorage.getItem("verbalHomePage")
      return this.verbalHomePage
    }
  },
  actions: {
    setEmailAddress(email) {
      this.email = email
      localStorage.setItem("email","" + email)
    },
    setIsMe(isMeFlag) {
      this.isMe = isMeFlag
      localStorage.setItem("isMe","" + isMeFlag)
    },
    setUserCookieDummy(cookie,dummy) {
      //console.log("in setUserCookieDummy",cookie,dummy)
      this.cookie = cookie
      localStorage.setItem("cookie",cookie)
      this.dummy = dummy
      localStorage.setItem("dummy",dummy)

      // zero out all the other fields on a setting of cookie & dummy. will reload from server
      this.lastStartupCheckDate = null
      this.lastNewInfoDate = null
      this.isSubscriber = null
      this.subscriberExpireDate = null
      this.subscriberExpireDisplayString = null
      this.isMe = null
      this.verified = null

      localStorage.removeItem("isSubscriber")
      localStorage.removeItem("lastStartupCheckDate")
      localStorage.removeItem("lastNewInfoDate")
      localStorage.removeItem("subscriberExpireDate")
      localStorage.removeItem("subscriberExpireDisplayString")
      localStorage.removeItem("isMe")
      localStorage.removeItem("emailVerified")
    },
    setPuzzleType(puzzleType) {
      this.puzzleType = puzzleType
      localStorage.setItem("puzzleType",puzzleType)
    },
    setEmailVerified(verified) {
      this.verified = verified
      localStorage.setItem("emailVerified","" + verified)
    },
    setLastStartupDate(startupDate) {
      this.lastStartupCheckDate = startupDate
      localStorage.setItem("lastStartupCheckDate","" + startupDate)
    },
    setLastNewInfoDate(startupDate) {
      this.lastNewInfoDate = startupDate
      localStorage.setItem("lastNewInfoDate","" + startupDate)
    },
    setLichessAccessToken(token) {
      this.lichessAccessToken = token
      localStorage.setItem("lichessAccessToken",token)
    },
    setLichessUserid(userid) {
      this.lichessUserid = userid
      localStorage.setItem("lichessUserid",userid)
    },
    setPlayComputerGameId(playComputerGameId) {
      this.playComputerGameId = playComputerGameId
      localStorage.setItem("playComputerGameId","" + playComputerGameId)
    },
    setReviewGameId(reviewGameId) {
      this.reviewGameId = reviewGameId
      localStorage.setItem("reviewGameId","" + reviewGameId)
    },
    setLichessGameId(lichessGameId) {
      this.lichessGameId = lichessGameId
      localStorage.setItem("lichessGameId",lichessGameId)
    },
    setLichessFriend(friendId,friendName) {
      this.lichessFriendId = friendId
      this.lichessFriendName = friendName
      localStorage.setItem("lichessFriendId",friendId)
      localStorage.setItem("lichessFriendName",friendName)
    },
    setVerbalHomePage(verbalHomePage) {
      this.verbalHomePage = verbalHomePage
      localStorage.setItem("verbalHomePage",verbalHomePage)
    },
    setDarkMode(darkmode) {
      this.darkmode = darkmode
      localStorage.setItem("dark",darkmode)
    },
    setDarkBoardColors(darkBoardColors) {
      this.darkBoardColors = darkBoardColors
      localStorage.setItem("darkBoardColors",darkBoardColors)
    },
    setCoordinateLocation(coordinateLocation) {
      this.coordinateLocation = coordinateLocation
      localStorage.setItem("coordinateLocation","" + coordinateLocation)
    },
    setIsSubscriber(isSubscriber) {
      this.isSubscriber = isSubscriber
      localStorage.setItem("isSubscriber","" + isSubscriber)
    },
    setSubscriberExpireDate(subscriberExpireDate) {
      this.subscriberExpireDate = subscriberExpireDate
      localStorage.setItem("subscriberExpireDate","" + subscriberExpireDate)
    },
    setSubscriberExpireDisplayString(subscriberExpireDisplayString) {
      this.subscriberExpireDisplayString = subscriberExpireDisplayString
      localStorage.setItem("subscriberExpireDisplayString",subscriberExpireDisplayString)
    },
  }

})
